<template>
  <div class="page_con">
    <div class="table detail">
      <div class="row head">
        <div class="cell">
          <p class="left">
            <span class="board_ttl">{{ item.title }}</span>
          </p>
        </div>
        <div class="cell fix240">          
          <!-- 홈페이지 유지보수 개발요청안 | 게시물다운로드 횟수 및 조회수 카운트 섹션 생성 (서남아이에스 임현아, 2024-07-01) -->  
          <p class="date" v-if="!$Util.isEmpty(files)">
            {{ $moment(item.regDate).format('YYYY.MM.DD') }} 
            <br/> <br/>
            조회수 : {{ item.views }} 회 <br/>
            다운로드 수 : {{ item.downloadCnt }} 회 <br/></p>
          <p class="date" v-else>
            {{ $moment(item.regDate).format('YYYY.MM.DD') }}
            <br/> <br/>
            조회수 : {{ item.views }} 회 <br/>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="cell detail_con">
          <div class="editor">
            <div v-html="item.contents"></div>
            <!--div 꼭 넣어주세요!-->
          </div>
        </div>
      </div>
      <div class="row" v-if="!$Util.isEmpty(files)">
        <div class="cell file_up">
          <div class="file_up_ttl">
            <span>첨부 파일</span>
          </div>
          <ul>
            <li :key="index" v-for="(item, index) in files">
              <button @click="fnDownload(item)">
                {{ item.fileName }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'news-view-index',
  props: {
    item: {
      type: [Object],
      default: () => {}
    },
    files: {
      type: [Array],
      default: () => []
    },
    no: {
      type: [Number],
      default: 1
    },
    boardType: {
      type: [Number],
      default: 1
    }
  },
  methods: {
    downloadItem: function(url, label) {
      axios
        .get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data])
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = label
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    },
    fnDownload: function(item) {
      const params = {}
      params.fileName = item.fileName
      params.filePath = item.imagePath
      this.$CommonSvc.downloadFile(params).then(res => {
        if(!this.$Util.isEmpty(item.fileName)) {
          const blob = new Blob([res.data], {
            type: res.data.type,
            encoding: 'UTF-8'
          })
          const a = document.createElement('a')
          a.href = URL.createObjectURL(blob)
          a.download = item.fileName
          a.target = '_blank'
          a.click()

          const params2 = {}
          params2.no = Number(this.no)
          params2.boardType = this.boardType

          // 홈페이지 유지보수 개발요청안 | 게시물다운로드 횟수 및 조회수 카운트 섹션 생성 (서남아이에스 임현아, 2024-07-01)
          this.$NewsSvc.downloadCnt(params2)

          this.$router.go(this.$router.currentRoute)
        }
      })
    }
  }
}
</script>

<style scoped></style>
